
















































import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import BrandContextMixin from '@spa/mixins/brandContext'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import ApiBrand from '@/models/api/brand'
import BrandSelect from '@spa/components/organisms/mypage/coupon/BrandSelect.vue'
import CouponList from '@spa/components/organisms/mypage/coupon/CouponList.vue'
import CreateCouponPageInteractor from '@spa/components/pages/mypage/coupon/interactor/create-coupon-page-interactor'
import FetchCouponInteractor from '@spa/components/pages/mypage/coupon/interactor/fetch-coupon-interactor'
import CouponService from '@spa/services/api/coupon'

import CouponCollection from './models/coupon-collection'
import CouponPage, { emptyCouponPage } from './models/coupon-page'

@Component({
  components: {
    BrandSelect,
    CouponList,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
    BrandContextMixin,
  ],
})
export default class Coupon extends Mixins<PluginMixin & BrandContextMixin>(PluginMixin, BrandContextMixin) {

  Status = Status
  status: Status = Status.Pending

  showModal: boolean = false
  modalMessage: string = ''

  currentPage: CouponPage = emptyCouponPage
  currentPageNumber: number = 1
  currentBrandEnglishName: string = ''
  listIsLoading: boolean = false
  hasNextPage: boolean = false

  collection: CouponCollection = new CouponCollection()
  brands: ApiBrand[] = []

  get isLoading(): boolean {
    return this.status === Status.Loading
  }

  get fetchInteractor(): FetchCouponInteractor {
    const service = CouponService.create()

    return new FetchCouponInteractor(service)
  }

  get createInteractor(): CreateCouponPageInteractor {
    return new CreateCouponPageInteractor()
  }

  async loadPage(pageNumber: number): Promise<CouponPage> {
    const page = this.createInteractor.createBrandPage(
      this.currentBrandEnglishName,
      pageNumber,
      this.collection,
      this.brands
    )
    if (page.isFulfilled) {
      return page
    }

    const commonLoadResult = await this.fetchInteractor.loadCommonCoupons(this.collection)

    if (commonLoadResult.isLeft()) {
      this.showModal = true
      this.modalMessage = 'クーポンが取得できませんでした。'

      return emptyCouponPage
    }

    this.collection = commonLoadResult.value

    const commonLoadedPage = this.createInteractor.createBrandPage(
      this.currentBrandEnglishName,
      pageNumber,
      this.collection,
      this.brands
    )
    if (commonLoadedPage.isFulfilled) {
      return commonLoadedPage
    }

    const brandLoadResult
      = await this.fetchInteractor.loadBrandCoupons(this.currentBrandEnglishName, this.collection)

    if (brandLoadResult.isLeft()) {
      this.showModal = true
      this.modalMessage = 'クーポンが取得できませんでした。'

      return emptyCouponPage
    }

    this.collection = brandLoadResult.value

    return this.createInteractor.createBrandPage(
      this.currentBrandEnglishName,
      pageNumber,
      this.collection,
      this.brands
    )
  }

  async created() {
    this.status = Status.Loading

    await Promise.all([
      this.initBrandList(),
    ])

    this.setUpBrand()

    this.status = Status.Completed
  }

  async onBrandSelected(brandEnglishName: string) {
    this.initWithBrandEnglishName(brandEnglishName)

    this.listIsLoading = true
    this.currentPage = await this.loadPage(this.currentPageNumber)
    this.listIsLoading = false

    this.hasNextPage = false
    if (this.currentPage.isFulfilled) {
      const nextPage = await this.loadPage(this.currentPageNumber + 1)
      this.hasNextPage = !nextPage.empty
    }
  }

  async onNewPageSelected(pageNumber: number) {
    this.currentPageNumber = pageNumber
    this.currentPage = await this.loadPage(this.currentPageNumber)

    this.hasNextPage = false
    if (this.currentPage.isFulfilled) {
      const nextPage = await this.loadPage(this.currentPageNumber + 1)
      this.hasNextPage = !nextPage.empty
    }
  }

  private setUpBrand() {
    this.brands = this.allBrands

    if (this.initialBrand === null) {
      return
    }
    this.onBrandSelected(this.initialBrand.englishName)

    this.brands = this.transferableBrands(this.initialBrand)
  }

  private initWithBrandEnglishName(brandEnglishName: string) {
    this.currentPage = emptyCouponPage
    this.currentPageNumber = 1
    this.currentBrandEnglishName = brandEnglishName
  }
}
